import React, {ReactNode, useCallback, useEffect} from 'react';
import {getProfilesSignalmanFeature} from '~/utils/signalman';
import rollbar from '~/vendor/rollbar';
import {Auth0ProviderWrapper} from '~/auth/auth0/Auth0ProviderWrapper';
import Cookies from 'cookies-js';
import {ProfilesProvider} from '~/auth/profiles/ProfilesProvider';

const PROFILES_SIGNALMAN_FEATURE = 'auth0_rollout';

const useIdentityProvider = () => {
  const [identityProvider, setIdentityProvider] = React.useState<
    'auth0' | 'profiles' | undefined
  >(undefined);

  const setIdentityProviderFromCookie = useCallback(
    (cookieValue: string) => {
      if (cookieValue === 'test') {
        setIdentityProvider('auth0');
      } else if (cookieValue === 'excluded' || cookieValue === 'control') {
        setIdentityProvider('profiles');
      } else {
        setIdentityProvider('profiles');
        rollbar.warning(
          `Profiles signalman auth0_rollout feature flag got unexpected value: ${cookieValue}`
        );
      }
    },
    [setIdentityProvider]
  );

  useEffect(() => {
    const cookieValue = Cookies.get(`feature_${PROFILES_SIGNALMAN_FEATURE}`);
    if (cookieValue) {
      setIdentityProviderFromCookie(cookieValue);
      return;
    }

    // cookie does not exist yet, we need to fetch the value from signalman
    getProfilesSignalmanFeature(PROFILES_SIGNALMAN_FEATURE)
      .then(setIdentityProviderFromCookie)
      .catch(error => {
        setIdentityProvider('profiles');
        rollbar.error(
          `Profiles signalman auth0_rollout feature flag fetch failed: ${error.message}`
        );
      });
  }, []);

  return identityProvider;
};

export const AuthProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const identityProvider = useIdentityProvider();

  if (identityProvider === 'profiles') {
    return <ProfilesProvider>{children}</ProfilesProvider>;
  }

  if (identityProvider === 'auth0') {
    return <Auth0ProviderWrapper>{children}</Auth0ProviderWrapper>;
  }

  return children;
};
